export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    html: {
      type: String,
      default: ''
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
      this.$emit('input', false);
    }
  },
  watch: {
    value: function value() {
      this.eventBus.$emit(this.value ? 'stopVideo' : 'playVideo');
    }
  }
};